import { createTypeGuard, TypeGuardOf } from "../lib/create-type-guard.js";
import { Unit } from "./unit.js";

export type ConditionData = {
  type: string;
  value: string | number;
};

export type Condition =
  | {
      type: Exclude<StringConditionType, "MAX_COUNT_IN_ARMY">;
      value: string;
    }
  | {
      type: Extract<StringConditionType, "MAX_COUNT_IN_ARMY">;
      value: number;
    };

type StringConditionType = TypeGuardOf<typeof isStringConditionType>;

const isStringConditionType = createTypeGuard([
  "HAS_PROFILE",
  "HAS_KEYWORD",
  "HAS_NOT_KEYWORD",
  "MAX_COUNT_IN_ARMY",
]);

// type CountConditionType = TypeGuardOf<typeof isCountConditionType>;

// const isCountConditionType = createTypeGuard(["MAX_COUNT_IN_ARMY"]);

export function isCondition(c: ConditionData): c is Condition {
  // Must be the right condition type
  if (!isStringConditionType(c.type)) {
    return false;
  }

  // If it is a MAX_COUNT_IN_ARMY, make sure that value is a number
  if (c.type === "MAX_COUNT_IN_ARMY") {
    return typeof c.value === "number";
  }

  // Otherwise make sure the value is a string
  return typeof c.value === "string";
}

export function checkCondition(keywordId: string, unit: Unit) {
  return (condition: Condition): boolean => {
    switch (condition.type) {
      case "HAS_PROFILE": {
        return unit.profile.id === condition.value;
      }

      case "HAS_KEYWORD": {
        return unit.keywords.some((k) => k.id === condition.value);
      }

      case "HAS_NOT_KEYWORD": {
        return !unit.keywords.some((k) => k.id === condition.value);
      }

      case "MAX_COUNT_IN_ARMY": {
        const count = unit.army.units.reduce(
          (acc, u) =>
            acc +
            u.keywords.filter((k) => k.id === keywordId).length * u.data.count,
          0,
        );
        return count <= condition.value;
      }

      // Unknown condition fails, but if other conditions in the list are
      // recognised, they might be successful, so the modifier might still
      // get applied.
      default: {
        return false;
      }
    }
  };
}

// abstract class ConditionBase {
//   owner: Keyword | StatModifier;

//   constructor(owner: Keyword | StatModifier) {
//     this.owner = owner;
//   }
// }

// class StringCondition extends ConditionBase {
//   data: { type: StringConditionType; value: string };

//   constructor(keyword: Keyword, conditionData: StringCondition["data"]) {
//     super(keyword);
//     this.data = conditionData;
//   }

//   get type() {
//     return this.data.type;
//   }

//   get value() {
//     return this.data.value;
//   }

//   get isValid() {
//     const conditionKeyword =
//       this.owner instanceof StatModifier ? this.owner.keyword : this.owner;

//     const unit =
//       conditionKeyword.owner instanceof Unit ? conditionKeyword.owner : null;

//       // If the keyword is
//     if (!unit) {
//       return false;
//     }

//     switch (this.type) {
//       case "HAS_PROFILE": {
//         return unit.profile.id === condition.value;
//       }

//       case "HAS_KEYWORD": {
//         return unit.keywords.some((k) => k.definition.id === condition.value);
//       }

//       case "HAS_NOT_KEYWORD": {
//         return !unit.keywords.some((k) => k.definition.id === condition.value);
//       }
//     }
//   }
// }

// class CountCondition extends ConditionBase {
//   data: { type: CountConditionType; value: number };

//   constructor(keyword: Keyword, conditionData: CountCondition["data"]) {
//     super(keyword);
//     this.data = conditionData;
//   }

//   get type() {
//     return this.data.type;
//   }

//   get count() {
//     return this.data.value;
//   }
// }
